window.NewsPreviewSlider = (randomId) => {
  return {
    swiper: null,
    init() {
      setTimeout(() => {
        this.swiper = new Swiper("#swiper-" + randomId, {
          breakpoints: {
            640: {
              slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 3,
              spaceBetween: 55,
            },
          },
          loop: false,
        watchOverflow: true,
        centerInsufficientSlides: true,
          grabCursor: true,
          a11y: true,
          navigation: {
            nextEl: ".swiper-button-next-" + randomId,
            prevEl: ".swiper-button-prev-" + randomId,
          },
        });
      }, 0);
    },
  };
};
